import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import {
  EntitySelectionControl,
  QueryBuilderControl,
  QueryDisplayControl,
  QueryImportControl,
  QueryTesterControl,
  type FetchXmlBuilderTree,
  type IFetchXmlBuilderDataSource,
} from "@kodikas/fetchxml-builder";

const useStyles = makeStyles({
  root: {
    display: "grid",
    gap: "12px",
    gridTemplateColumns: "minmax(200px, 1fr) minmax(320px, 1fr)",
    alignItems: "stretch",
    height: "100%",
    minHeight: 0,
    "@media (max-width: 1100px)": {
      gridTemplateColumns: "1fr",
    },
  },
  connectionRow: {
    gridColumn: "1 / -1",
  },
  builderColumn: {
    minWidth: 0,
    minHeight: 0,
  },
  toolsColumn: {
    display: "grid",
    gap: "12px",
    alignContent: "start",
    minWidth: 0,
  },
});

export interface FetchXmlBuilderControlProps {
  dataSource: IFetchXmlBuilderDataSource | null;
  tree: FetchXmlBuilderTree | null;
  onTreeChange: (tree: FetchXmlBuilderTree | null) => void;
}

export function FetchXmlBuilderControl({ dataSource, tree, onTreeChange }: FetchXmlBuilderControlProps): JSX.Element {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.builderColumn}>
        <EntitySelectionControl dataSource={dataSource} tree={tree} onTreeChange={onTreeChange} />
        <QueryBuilderControl dataSource={dataSource} tree={tree} onTreeChange={onTreeChange} />
      </div>

      <div className={styles.toolsColumn}>
        <QueryImportControl onImportTree={onTreeChange} />
        <QueryTesterControl dataSource={dataSource} tree={tree} />
        <QueryDisplayControl tree={tree} />
      </div>
    </div>
  );
}
